/**
 * Leviathan Web - Route-level Error Boundary
 * Quasar Prime LLC
 *
 * Wraps whatever the router is currently rendering, INSIDE the dashboard
 * layout, so a screen that throws leaves the sidebar and header intact and the
 * operator can simply click somewhere else.
 *
 * Keyed on the pathname: navigating to another route clears the caught error,
 * so recovery does not require a reload.
 */

import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';

export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  const location = useLocation();

  return (
    <ErrorBoundary resetKey={location.pathname} label={`the ${location.pathname} screen`}>
      {children}
    </ErrorBoundary>
  );
}

export default RouteErrorBoundary;
